import { FunctionComponent, MouseEvent } from 'react'
import cx from 'classnames'
import { NEVER } from 'rxjs'
import { map, distinctUntilChanged } from 'rxjs/operators'
import { kebabCase, mapKeys } from 'libraries/lodash'
import { AccordionFixedHelper } from 'services/AccordionService'
import GroupHeaderContainer from 'redux/containers/components/accordion/GroupHeaderContainer'
import ContentHeaderContainer from 'redux/containers/components/accordion/ContentHeaderContainer'
import useBaseState from 'hooks/useBaseState'
import { NodeType } from 'types/Accordion'

const AccordionHeader:FunctionComponent<AccordionHeaderProps> = (props) => {
  const { id, path, atBottom = 0, selected, depth, nodeType, showAllS1, editMode, expanded: _expanded } = props
  const _id = path.join('/')
  const { baseState: { visible } } = useBaseState<{visible: boolean}>(
    atBottom
      ? AccordionFixedHelper.pipe(
          map(fixed => fixed === _id),
          distinctUntilChanged(),
          map(visible => ({ visible }))
      )
      : NEVER,
    { visible: !atBottom },
    [_id]
  )
  const selectable = !editMode && selected !== undefined
  const expanded = _expanded > 0

  const className = cx(
    {
      show: visible,
      selectable,
      'scroll-adjust-height': true,
      ['depth-' + depth]: true
    }
  ).toString()

  switch (nodeType) {
    case 'content':
      // FIX ME fix the prop types
      return (
        <ContentHeaderContainer {...{
          ...props,
          path,
          id: _id,
          expanded,
          className
        }}
        nodeId={id}/>
      )
    case 'group':
      // FIX ME fix the prop types
      return (
        !(depth === 1 && expanded && !showAllS1) && (
          <GroupHeaderContainer
            {...{
            ...props,
            id: _id,
            expanded,
            className,
            nodeId: id
            }}
          />
        )
      )
    default:
      return null
  }
}

export interface AccordionHeaderProps{
  id: string;
  path: string[];
  atBottom: number;
  depth: number;
  selected: any; // FIX ME found both number and boolean
  nodeType: NodeType;
  showAllS1: boolean;
  editMode: boolean;
  expanded: any; // FIX ME found both number and boolean
  sticky?: number;
  className: string;
  comments: any[]; // FIX ME
  commentsId: string;
  prefix: string;
  suffix: string;
  addComment: any; // FIX ME
  cxNames: any; // FIX ME
  isHighlighted: boolean;
  eventCategory: string;
  handleOnClick: (e: MouseEvent<HTMLElement>) => void;
}

export default AccordionHeader

export const toDataProps = function (props: Object) {
  return mapKeys(props, (_v, k) => `data-${kebabCase(k)}`)
}
